import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Firebase config (same project as main app)
const firebaseConfig = {
  apiKey: "AIzaSyDE-gSA4dVklGu6fFZPaxwc2BRnghGoT1M",
  authDomain: "coredeck-90a56.firebaseapp.com",
  projectId: "coredeck-90a56",
  storageBucket: "coredeck-90a56.firebasestorage.app",
  messagingSenderId: "512734234660",
  appId: "1:512734234660:web:685a52ab28d2b90d9e30b1",
  measurementId: "G-V00BRXEP1Q",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

export const authReady = new Promise((resolve) => {
  const unsub = onAuthStateChanged(auth, (user) => {
    unsub();
    resolve(user || null);
  });
});

export default app;